export const manifest = {
  screens: {
    scr_x0wlor: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_qxjw8r: { name: "About", route: "/about", position: {"x":1560,"y":220} },
    scr_1and0r: { name: "Gallery", route: "/gallery", position: {"x":4360,"y":220} },
    scr_kg4nbi: { name: "Financing", route: "/financing", position: {"x":160,"y":2200} },
    scr_tryb8p: { name: "Quote", route: "/quote", position: {"x":1560,"y":2200} },
  },
  sections: {
    sec_nl38hx: { name: "Main Navigation", x: 0, y: 0, width: 5720, height: 1180 },
    sec_13s9b2: { name: "Financing & Quote", x: 0, y: 1980, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_nl38hx", children: [
      { kind: "screen", id: "scr_x0wlor" },
      { kind: "screen", id: "scr_qxjw8r" },
      { kind: "screen", id: "scr_7mziga" },
      { kind: "screen", id: "scr_1and0r" },
    ] },
    { kind: "section", id: "sec_13s9b2", children: [
      { kind: "screen", id: "scr_kg4nbi" },
      { kind: "screen", id: "scr_tryb8p" },
    ] },
  ],
}
